export const actionName = {
  HIDE_ERROR_POPUP: 'HIDE_ERROR_POPUP'
};
